/**
 * Language Switcher dropdown functionality
 * 
 * @module components/ui/language-switcher
 */

import { load } from "../../events/load";

/**
 * Initialize language switcher dropdown behavior
 */
const initLanguageSwitcher = () => {
    const switchers = document.querySelectorAll('[data-lang-switcher]');

    if (!switchers.length) return;

    switchers.forEach((switcher) => {
        const button = switcher.querySelector('.header__lang-btn');
        const dropdown = switcher.querySelector('.header__lang-dropdown');

        if (!button || !dropdown) return;

        /**
         * Toggle dropdown visibility
         */
        const toggleDropdown = () => {
            const isOpen = switcher.classList.contains('is-open');

            if (isOpen) {
                closeDropdown();
            } else {
                openDropdown();
            }
        };

        /**
         * Open dropdown
         */
        const openDropdown = () => {
            switcher.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
        };

        /**
         * Close dropdown
         */
        const closeDropdown = () => {
            switcher.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
        };

        // Toggle on button click
        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown();
        });

        // Close on click outside
        document.addEventListener('click', (e) => {
            if (!switcher.contains(e.target)) {
                closeDropdown();
            }
        });

        // Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeDropdown();
                button.focus();
            }
        });

        // Keyboard navigation within dropdown
        dropdown.addEventListener('keydown', (e) => {
            const items = dropdown.querySelectorAll('.header__lang-item');
            const currentIndex = Array.from(items).indexOf(document.activeElement);

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
                items[nextIndex]?.focus();
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                const prevIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
                items[prevIndex]?.focus();
            }
        });
    });
};

load(initLanguageSwitcher);
